<template>
  <CoreSwiper>
    <template #slides="{ slideAttrs }">
      <div
        v-for="doctorRate in doctorRates"
        :key="doctorRate.doctor.id"
        v-bind="slideAttrs"
      >
        <div class="d-flex flex-column gr-4 elevation-1 rounded-sm pa-4 mx-2">
          <div class="d-flex gc-4">
            <a
              class="text-decoration-none"
              :href="`/${doctorRate.doctor.url}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-img
                class="rounded-lg"
                :src="doctorRate.doctor.avatar"
                lazy-src="/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg"
                :alt="t('Аватар', options)"
                width="80"
                height="80"
              />
            </a>
            <div class="d-flex flex-column">
              <a
                :href="`/${doctorRate.doctor.url}`"
                class="text-subtitle-1 text-decoration-none primary--text"
              >
                {{ transDynamic(doctorRate.doctor, `fio,${languageIso},${needTranslate}`) }}
              </a>
              <span class="text-body-1 text-info--text">
                {{ transDynamic(doctorRate.doctor, `meta,${languageIso},${needTranslate}`) }}
              </span>
            </div>
          </div>

          <div class="text-body-1 text--text">
            {{ doctorRate.rateText }}
          </div>
        </div>
      </div>
    </template>
  </CoreSwiper>
</template>

<script lang="ts" setup>
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const needTranslate = context.need_translate
const languageIso = context.current_language?.iso ?? ''

defineProps<{
  doctorRates: Array<{
    doctor: {
      meta: string
      id: number
      avatar: string
      fio: string
      url: string
    }
    rateText: string
    width: string
  }>
}>()
</script>
